import { useMutation } from '@apollo/client'
import { RunGroupClearance, RunGroupClearanceVariables } from '../../types'
import { RUN_GROUP_CLEARANCE } from './operations'

export const useRunGroupClearance = () =>
  useMutation<RunGroupClearance, RunGroupClearanceVariables>(RUN_GROUP_CLEARANCE)
